import { render, staticRenderFns } from "./astdBknDny.vue?vue&type=template&id=1fa860fc"
import script from "./astdBknDny.vue?vue&type=script&lang=js"
export * from "./astdBknDny.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports